import React, { useContext, useEffect, useState } from 'react';
import './index.scss';
import { Outlet, useLocation } from 'react-router-dom';
import SideBarComponent from '../AboutSidebar';
import MenubarLanding from '../../MenubarLanding';

/**
 * The `AboutLayout` component serves as the main layout for the About section,
 * dynamically switching between `MenuInterior` and `MenubarLanding` based on the current route.
 * It includes a sidebar for navigation and renders different content using the `Outlet` component
 * provided by `react-router-dom`. The layout adapts to different sub-sections of About,
 * ensuring a consistent and navigable user interface.
 */
const AboutLayout = () => {


    return (
        <div className="about-container">
            <MenubarLanding />
            <div className="about-layout">
                <SideBarComponent />
                <div className="about-content">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default AboutLayout;
